import { Role } from '@guiker/permissions'

import { BackgroundCheckActions } from '../background-check-actions'
import { BackgroundCheckRoleNames } from '../role-names'

export const RequesterRole: Role = {
  name: BackgroundCheckRoleNames.REQUESTER,
  permissions: [{ action: BackgroundCheckActions.ConductBackgroundCheck }],
}
